/* eslint-disable-next-line @typescript-eslint/no-restricted-imports --
 * Type-only import. This code still shouldn't import from the index, but the
 * lazy import was there before I had to add the type import for `isolatedDeclarations`
 */
import type * as index from './index';
import { LazyBootModule, LazyAction } from 'owa-bundling-light';

const lazyModule: LazyBootModule<typeof index> = new LazyBootModule<typeof index>(
    () => import(/* webpackChunkName: "AppBootLocalDataAccountSupport" */ './index'),
    { name: 'AppBootLocalDataAccountSupport' }
);

export const lazyAddLocalDataAdditionalAccountProxy: LazyAction<
    typeof index.lazyAddLocalDataAdditionalAccount.importAndExecute,
    typeof lazyModule
> = new LazyAction(lazyModule, m => m.lazyAddLocalDataAdditionalAccount.importAndExecute);

export const lazyDoCleanupForRemovedLocalDataAccountProxy: LazyAction<
    typeof index.lazyDoCleanupForRemovedLocalDataAccount.importAndExecute,
    typeof lazyModule
> = new LazyAction(lazyModule, m => m.lazyDoCleanupForRemovedLocalDataAccount.importAndExecute);

export const lazyCheckM365InstallationProxy: LazyAction<
    typeof index.lazyCheckM365Installation.importAndExecute,
    typeof lazyModule
> = new LazyAction(lazyModule, m => m.lazyCheckM365Installation.importAndExecute);

export const lazyCheckPstPrerequisitesProxy: LazyAction<
    typeof index.lazyCheckPstPrerequisites.importAndExecute,
    typeof lazyModule
> = new LazyAction(lazyModule, m => m.lazyCheckPstPrerequisites.importAndExecute);

export const lazyCheckBulkTransferPrerequisitesProxy: LazyAction<
    typeof index.lazyCheckBulkTransferPrerequisites.importAndExecute,
    typeof lazyModule
> = new LazyAction(lazyModule, m => m.lazyCheckBulkTransferPrerequisites.importAndExecute);

export const lazyCheckExportToPstPrerequisitesProxy: LazyAction<
    typeof index.lazyCheckExportToPstPrerequisites.importAndExecute,
    typeof lazyModule
> = new LazyAction(lazyModule, m => m.lazyCheckExportToPstPrerequisites.importAndExecute);
